import React from "react";
import { useSelector } from "react-redux";

import { OPERATIONAL_CHECK_INSURANCE_ELIGIBILITY_FLAG } from "@/constants/featureFlags";

import { FeatureGate } from "../FeatureGate/FeatureGate";

import InsuranceEligibilityV2 from "./InsuranceEligibilityV2/InsuranceEligibilityV2";
import SkipInsuranceEligibility from "./SkipInsuranceEligibility/SkipInsuranceEligibility";

const InsuranceEligibilityWrapper = ({
  accountData,
  eligibilityCallback,
  entryPoint,
  insuranceDetails,
  setEligibilityMessage = () => {},
  setRequiredFields = () => {},
  submissionAttempts,
  ...props
}) => {
  const publicFlags = useSelector((state) => state.flags.publicFlags);
  const publicFlagsHaveLoaded = useSelector((state) => state.flags.publicFlagsHaveLoaded);

  return (
    <FeatureGate
      alternateFlagDisabledBehavior={
        <SkipInsuranceEligibility
          eligibilityCallback={eligibilityCallback}
          submissionAttempts={submissionAttempts}
        />
      }
      defaultFlagBehavior={true}
      enabled={publicFlags?.[OPERATIONAL_CHECK_INSURANCE_ELIGIBILITY_FLAG]}
      flagName={OPERATIONAL_CHECK_INSURANCE_ELIGIBILITY_FLAG}
      hasLoaded={publicFlagsHaveLoaded}
    >
      <InsuranceEligibilityV2
        accountData={accountData}
        eligibilityCallback={eligibilityCallback}
        entryPoint={entryPoint}
        insuranceDetails={insuranceDetails}
        props={props}
        setEligibilityMessage={setEligibilityMessage}
        setRequiredFields={setRequiredFields}
        submissionAttempts={submissionAttempts}
      />
    </FeatureGate>
  );
};

export default InsuranceEligibilityWrapper;
